import { useMutation } from 'react-query';
import tracking from 'utils/tracking';
import axios from 'axios';
import { User } from 'types/user';

const baseUrl = process.env.REACT_APP_CEREBRAL_PLATFORM_URL || 'https://platform.cerebral.com';

export type CreateZocdocPatientRequest = {
  zocdocAppointmentId: string;
  patientUserId: number;
};

export const useCreateZocdocPatient = () => {
  const createZocdocPatientMutation = useMutation({
    mutationFn: async ({ user, zocdocAppointmentId }: { user: User; zocdocAppointmentId?: string }) => {
      if (zocdocAppointmentId) {
        try {
          const response = await axios.post(`${baseUrl}/api/v1/partner-integration-service/zocdoc/patients`, {
            zocdocAppointmentId,
            patientUserId: user.id
          } as CreateZocdocPatientRequest);
          if (response.status < 200 || response.status >= 300) {
            throw new Error('Failed to create Zocdoc patient');
          }
          return response.data;
        } catch (error) {
          tracking.errorV2('Fail to create Zocdoc patient', error as Error, {
            tags: ['ZocdocPatient', 'error'],
            zocdocAppointmentId,
            apiName: '/api/v1/partner-integration-service/zocdoc/patients'
          });
          return null;
        }
      }
      return null;
    }
  });
  return createZocdocPatientMutation;
};
